import { FlowConnector } from '../../../../_components/flow-builder/TypeDefs';
import { buildCondExpForbiddenKeysForUi, type FlowItemMergeRef } from './AndMergeForkGraph';
import { checkBusinessToBusinessConnector, getFlowConnectorButtons, getFlowConnectorConfig } from './ConnectorsHelpers';
import { FlowConnectorButtonActions, FlowItemDataMap } from '../TypeDefs';

export {
  canReachNode,
  clearCondExprForAndMergeCorridor,
  countForkOutboundCondExpressions,
  countStoredCondExprForMergeCorridor,
  findDivergenceForkForMerge,
  getAndMergeNodeIdsFromFlowItems,
  isCondExpForbiddenOnConnector,
  listClearableCondExprIngressLabelsForMerge,
  toFlowMergeRefs,
} from './AndMergeForkGraph';

export type { FlowItemMergeRef } from './AndMergeForkGraph';

/**
 * Sets connector buttons/config for conditional-expression affordance on every connector.
 * Shallow-clones each connector so callers can pass Redux state arrays without mutating prior references.
 */
export function applyConnectorConditionalExpressionRules(
  flowConnectors: FlowConnector[],
  andMergeNodeIds: Set<string>,
  flowItems: FlowItemMergeRef[],
  flowItemDataMap: FlowItemDataMap,
  viewJourneyInitiated: boolean,
  designingCEM: boolean
): FlowConnector[] {
  const working = flowConnectors.map((c) => ({ ...c }));
  const forbidden = buildCondExpForbiddenKeysForUi(andMergeNodeIds, working, flowItems);
  working.forEach((c) => {
    if (!c.fromNodeId) {
      return;
    }
    // Root/schema-only connectors carry no cond-exp or delete buttons; skip.
    if (c.buttons?.length === 1 && c.buttons[0].id === FlowConnectorButtonActions.VIEW_EVENT_SCHEMA) {
      return;
    }
    const convergence = working.filter((fc) => fc.toNodeId === c.toNodeId).length > 1;
    const fromData = flowItemDataMap[c.fromNodeId];
    const toData = flowItemDataMap[c.toNodeId];
    const allowCondExp = !forbidden.has(`${c.fromNodeId}\0${c.toNodeId}`);
    c.buttons = getFlowConnectorButtons(
      convergence,
      viewJourneyInitiated,
      checkBusinessToBusinessConnector(fromData?.serviceType, toData?.serviceType),
      designingCEM,
      allowCondExp
    );
    const hasStoredExpr = !!(flowItemDataMap[c.toNodeId]?.condExpr?.[c.fromNodeId]?.rawExpression
      || flowItemDataMap[c.toNodeId]?.condExpr?.[c.fromNodeId]?.builderExpression);
    c.config = getFlowConnectorConfig({
      hasCondExpr: allowCondExp && hasStoredExpr,
      mep: !!toData?.isExternal,
      external: !!fromData?.isExternal,
    });
  });
  return working;
}
